(() => {
  if (window.LmcdOlivaClone?.mount) {
    window.LmcdOlivaClone.mount(document);
    return;
  }

  const rootSelector = '[data-lmcd-oliva-clone]';

  const mountGallery = (gallery) => {
    const stage = gallery.querySelector('[data-oliva-gallery-stage]');
    const thumbnails = [...gallery.querySelectorAll('[data-oliva-gallery-thumbnail]')];
    if (!stage || !thumbnails.length) return;

    const select = (index) => {
      const selected = (index + thumbnails.length) % thumbnails.length;
      const thumbnail = thumbnails[selected];
      stage.src = thumbnail.dataset.olivaGallerySrc;
      stage.alt = thumbnail.dataset.olivaGalleryAlt;
      gallery.dataset.olivaGalleryIndex = String(selected);
      thumbnails.forEach((item, itemIndex) => item.setAttribute('aria-current', String(itemIndex === selected)));
    };

    thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', () => select(index)));
    gallery.querySelector('[data-oliva-gallery-prev]')?.addEventListener('click', () => {
      select(Number(gallery.dataset.olivaGalleryIndex || 0) - 1);
    });
    gallery.querySelector('[data-oliva-gallery-next]')?.addEventListener('click', () => {
      select(Number(gallery.dataset.olivaGalleryIndex || 0) + 1);
    });

    const zoom = gallery.querySelector('[data-oliva-gallery-zoom]');
    const dialog = gallery.querySelector('[data-oliva-gallery-dialog]');
    const dialogImage = dialog?.querySelector('[data-oliva-gallery-dialog-image]');
    const close = dialog?.querySelector('[data-oliva-gallery-close]');
    if (zoom && dialog && dialogImage && close) {
      zoom.addEventListener('click', () => {
        dialogImage.src = stage.src;
        dialogImage.alt = stage.alt;
        dialog.showModal();
        close.focus();
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => zoom.focus());
    }
  };

  const mountVideos = (root) => {
    const videos = [...root.querySelectorAll('[data-oliva-video] video')];
    const syncSound = (video) => {
      const wrapper = video.closest('[data-oliva-video]');
      const button = wrapper?.querySelector('[data-oliva-video-sound]');
      if (!button) return;
      const label = wrapper.dataset.olivaVideoLabel || video.getAttribute('aria-label') || 'video';
      button.setAttribute('aria-pressed', String(!video.muted));
      button.setAttribute('aria-label', video.muted ? `Play ${label} with sound` : `Mute ${label}`);
      button.textContent = video.muted ? 'Sound on' : 'Sound off';
    };
    const pauseSiblings = (current) => videos.forEach((video) => {
      if (video === current) return;
      video.pause();
      video.muted = true;
      syncSound(video);
    });

    videos.forEach((video) => {
      video.muted = true;
      syncSound(video);
      const button = video.closest('[data-oliva-video]')?.querySelector('[data-oliva-video-sound]');
      button?.addEventListener('click', () => {
        if (!video.muted) {
          video.muted = true;
          syncSound(video);
          return;
        }
        pauseSiblings(video);
        video.muted = false;
        syncSound(video);
        const attempt = video.play();
        attempt?.catch?.(() => {
          video.muted = true;
          syncSound(video);
        });
      });
      video.addEventListener('play', () => {
        if (!video.muted) pauseSiblings(video);
      });
      video.addEventListener('volumechange', () => syncSound(video));
    });
  };

  const initialize = (root) => {
    if (root.dataset.lmcdOlivaReady === 'true') return;
    root.dataset.lmcdOlivaReady = 'true';
    root.querySelectorAll('[data-oliva-gallery]').forEach(mountGallery);
    mountVideos(root);
  };

  const mount = (scope = document) => {
    if (scope.matches?.(rootSelector)) initialize(scope);
    scope.querySelectorAll?.(rootSelector).forEach(initialize);
  };

  window.LmcdOlivaClone = { mount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), {once: true});
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
